import Http from "./http";

export const getGroupProductFeatureContentAPI = (data) => {
    return Http.post("admin/group/getGroupProductFeatureContent", data);
};
